import { useQuery } from '@tanstack/react-query';
import { fetchSupportChatModuleTagsAPI } from '../../../api/supportChatModuleTags';
import { notifyError } from '../../../utils/notify';

const fetchSupportChatModuleTags = async () => {
  const { data } = await fetchSupportChatModuleTagsAPI();
  // API returns { data: [...] }, so we need to extract the array
  return data?.data || [];
};

const useGetSupportChatModuleTagsQuery = () =>
  useQuery(['supportChatModuleTags'], () => fetchSupportChatModuleTags(), {
    retry: false,
    onError: e => {
      notifyError(e, false, 'Error fetching support chat module tags');
    },
  });

export default useGetSupportChatModuleTagsQuery;
